// extracted by mini-css-extract-plugin
export var featuredArticlesCard = "FeaturedArticles-module--featured-articles-card--7e6e4";
export var featuredArticlesHeader = "FeaturedArticles-module--featured-articles-header--ebb5d";
export var featuredArticlesSection = "FeaturedArticles-module--featured-articles-section--19b0a";
export var featuredArticlesWrapper = "FeaturedArticles-module--featured-articles-wrapper--ba26a";
export var iconWrapper = "FeaturedArticles-module--icon-wrapper--85a70";
export var textWrapper = "FeaturedArticles-module--text-wrapper--3ccdb";